module.exports = __webpack_public_path__ + "d8c6b8e8b520b508da7f55ec550ccf6e.pdf";